<template lang="pug">
  div.page--blog-single.page(:key="$route.params.slug")
    page-header(
      :breadcrumb-only="false"
      header-class="page-header--blog-single"
      header-background="/img/frontend/page/blog-header-default-background.jpg"
    )
    .blog-single(v-if="post")
        .container
          .row
            .col-12
              .blog-single__header
                .row.no-gutters.h-100
                  .col-lg-7.h-100
                    img.featured-blog__image(:src='post.image', alt='')
                  .col-lg-5
                    .blog-single__content
                      h2.blog-single__title {{ post.post_title }}
                      p.blog-single__description {{ post.short_description }}
                      .blog-single__author(v-if="post.user_data")
                        .row
                          .col-auto
                            .featured-blog__author-thumbnail
                              img(:src='post.user_avatar.full', alt='' v-if="post.user_avatar")
                          .col
                            .blog-single__meta
                              p
                                | {{ trans('labels.frontend.blog.article_by') }}
                                span.ml-1 {{ post.user_data.display_name }}
                              p {{ trans('labels.frontend.blog.on') }} {{ post.post_date | moment('D/M/Y') }} {{ trans('labels.general.time') }} {{ post.post_date | moment('HH:mm') }}
          .row.justify-content-center
            .col-lg-8
              .blog-single__body(v-html="post.content" v-if="!post.is_elementor")
              .blog-single__body(v-if="post.is_elementor")
                elementor-component(:object-id="post.ID" object-type="template")
          .row(v-if="similarPosts && similarPosts.length > 0")
            .col
              h4.blog-related__title {{ trans('labels.frontend.blog.related_articles') }}
          .blog-list.row.mb-5.pt-0.blog-list--no-background
            blog-item(:post="similarPost" v-for="similarPost in similarPosts" :key="similarPost.ID")
</template>

<script>
import matchHeight from 'jquery-match-height';
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import BlogItem from './loop/BlogItem.vue';
import ElementorComponent from '../../components/ElementorComponent.vue';
import PageHeader from '../../components/layouts/PageHeader.vue';
import { RepositoryFactory } from '../../repositoryFactory';

window.matchHeight = matchHeight;

const BlogRepository = RepositoryFactory.get('blog');

export default {
  components: {
    BlogItem,
    ElementorComponent,
    PageHeader,
  },
  mixins: [BreadcrumbsManager],
  data() {
    return {
      post: {},
      similarPosts: [],
    };
  },
  metaInfo() {
    return {
      title: this.post.meta_tags ? this.post.meta_tags.title : this.post.post_title,
      meta: [{
        name: 'description',
        content: this.post.meta_tags ? this.post.meta_tags.description : this.post.post_title,
      },{
        name: 'keywords',
        content: this.post.meta_tags ? this.post.meta_tags.keywords : '',
      }, {
        property: 'og:title',
        content: this.post.meta_tags ? this.post.meta_tags.title : this.post.post_title,
      }, {
        property: 'og:description',
        content: this.post.meta_tags ? this.post.meta_tags.description : this.post.post_title,
      }, {
        property: 'og:image',
        content: this.post.image ?? false,
      }],
    };
  },
  watch: {
    $route() {
      this.post = {};
      this.similarPosts = [];
      this.getBlog();
    },
  },
  mounted() {
    this.getBlog();
  },
  methods: {
    async getBlog() {
      const { data } = await BlogRepository.post().getBySlug(this.$route.params.slug).then((resp) => resp.data);
      this.post = data;
      this.getRelatedPosts();
      this.setBreadcrumbs([
        { name: Lang.get('menus.frontend.navigation.articles'), to: { name: 'blog.index' } },
        {
          name: this.post.main_category,
          to: {
            name: 'blog.category.index', params: { slug: this.post.main_category_slug },
          },
        },
        { name: this.post.post_title },
      ]);
    },
    async getRelatedPosts() {
      const { data } = await BlogRepository.post().get({
        sort: 'post_date|desc', limit: 4, not_in: [this.post.ID], paginated: false, category: this.post.main_category_slug,
      }).then((resp) => resp.data);
      this.similarPosts = data;

      Vue.nextTick(() => {
        $('.blog-list__item-body').matchHeight();
      });
    },
  },
};
</script>
